import { useEffect } from "react";

export function useScrollReveal(containerRef) {
  useEffect(() => {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (prefersReduced) {
      const root = containerRef?.current ?? document;
      const elements =
        root === document
          ? document.querySelectorAll(".scroll-reveal")
          : root.querySelectorAll(".scroll-reveal");
      elements.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    const root = containerRef?.current ?? document;
    const elements =
      root === document
        ? document.querySelectorAll(".scroll-reveal")
        : root.querySelectorAll(".scroll-reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          } else {
            entry.target.classList.remove("is-visible");
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -32px 0px" }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [containerRef]);
}
